import type {ListModuleConfig} from "~/domainModels/listView/listModuleConfig";
import type {
    TableRowActionsMenuItem,
    TableRowActionsToolbarItem,
} from "~/components/table/tableRowActions.types";

export function resolveEventRowEngagementCapabilities({
    listConfig,
    showDisposition,
    showNotes,
    includeCreateDrawer,
    listCreateDrawerItemsCount,
    hasScheduleAction,
    hasLogCallAction,
    isArchiveAvailable,
    showProfile,
    isArchivedView,
}: {
    listConfig: ListModuleConfig | null;
    showDisposition: boolean;
    showNotes: boolean;
    includeCreateDrawer: boolean;
    listCreateDrawerItemsCount: number;
    hasScheduleAction: boolean;
    hasLogCallAction: boolean;
    isArchiveAvailable: boolean;
    showProfile: boolean;
    isArchivedView: boolean;
}): {
    toolbar: TableRowActionsToolbarItem[];
    moreMenu: TableRowActionsMenuItem[];
} {
    if (isArchivedView === true) {
        return {
            toolbar: ["view"],
            moreMenu: [],
        };
    }

    const toolbar: TableRowActionsToolbarItem[] = [];
    if (showProfile === true) {
        toolbar.push("profile");
    }
    if (showDisposition === true) {
        toolbar.push("disposition");
    }
    toolbar.push("edit", "more");

    const moreMenu: TableRowActionsMenuItem[] = ["view"];
    if (hasLogCallAction === true) {
        moreMenu.push("logCall");
    } else if (includeCreateDrawer === true && listCreateDrawerItemsCount > 0) {
        moreMenu.push("create");
    }
    if (showNotes === true && listConfig?.showFooter === true) {
        moreMenu.push("notes");
    }
    if (hasScheduleAction === true) {
        moreMenu.push("scheduleCall");
    }
    if (isArchiveAvailable === true) {
        moreMenu.push("archive");
    }

    return {toolbar, moreMenu};
}
